import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setImmunizationTypeOptions } from '../store/options.actions'

export function* getImmunizationTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getImmunizationTypeOptions,
    ])
    const { entity } = response
    yield put(setImmunizationTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getImmunizationTypeOptions() error: ${e}`))
  }
}

export function* getImmunizationTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getImmunizationTypeOptions)
}
